import { FormRequestHandler } from "@/forms/FormRequestHandler";
import { FormResponse } from "@/forms/FormResponse";
import { DateUtils } from "@/utils/DateUtils";
import {
  IWorkOrderService,
  WorkOrder,
  WorkOrderReportXlsxResponse
} from "../services/WorkOrderService";

export class SendReportToLabController {
  public constructor(
    private presenter: ISendReportToLabPresenter,
    private workOrderService: IWorkOrderService
  ) {}

  public mounted(week?: string) {
    this.presenter.mounted();

    FormRequestHandler.handle(
      this.workOrderService.getAllFinishedWorkOrdersWithoutLabReport(week),
      response => (this.presenter.getReportsResponse = response),
      "Konnte Arbeitsaufträge nicht laden!"
    );
  }

  public parseDate(date: string) {
    return DateUtils.format(date);
  }

  public parseFileSize(fileSize: number) {
    if (fileSize > 1000000) {
      return `${(fileSize / 1000000).toFixed(2)} MB`;
    } else if (fileSize > 1000) {
      return `${(fileSize / 1000).toFixed(2)} KB`;
    } else {
      return `${fileSize} B`;
    }
  }

  public weekNumber(date: string) {
    return `KW ${DateUtils.weekNumber(date)} / ${DateUtils.getDate(
      date
    ).getFullYear()}`;
  }

  public removeTableItem(id: string) {
    this.presenter.removeTableItem(id);
  }

  public downloadReportXlsx(id: string) {
    FormRequestHandler.handle(
      this.workOrderService.downloadReportXlsx(id),
      response => (this.presenter.downloadReportXlsxResponse = response),
      "Konnte Bericht nicht herunterladen!",
      () => ({ workOrderId: id })
    );
  }

  public sendReports() {
    FormRequestHandler.handle(
      this.workOrderService.sendReportsToLab(this.presenter.data),
      response => (this.presenter.sendReportsResponse = response),
      "Konnte Berichte nicht senden!"
    );
  }
}

export interface ISendReportToLabPresenter {
  getReportsResponse: FormResponse<WorkOrder[]>;
  sendReportsResponse: FormResponse<string>;
  downloadReportXlsxResponse: FormResponse<WorkOrderReportXlsxResponse>;
  data: any;

  mounted(): void;
  removeTableItem(id: string): void;
}
